import Image from 'next/image';
import Link from 'next/link';

export const BookingForm = ({ data, isLightTheme }) => {
  return (
    <article
      className={`w-full rounded-[18px] ${
        isLightTheme
          ? 'bg-white'
          : 'bg-gradient-to-b from-[#1717172b] via-[#2d37372b] to-[#1717172b] border border-[#0C3438]'
      }`}
    >
      <div className="px-5 pt-4 pb-7">
        <div className="relative aspect-square rounded-[10px] overflow-hidden">
          <Image
            src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${data?.form_img?.id}`}
            alt={data?.form_heading || 'Booking form image'}
            fill
            className="object-cover"
            quality={85}
            loading="lazy"
            placeholder="blur"
            blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZTBlMGUwIi8+PC9zdmc+"
          />
        </div>

        <div className="mt-[11px]">
          {data?.form_heading && (
            <p
              className={`mb-[3px] font-instrument-serif text-[20px] leading-none ${
                isLightTheme ? 'text-black' : 'text-white'
              }`}
            >
              {data?.form_heading}
            </p>
          )}
          <p
            className={`${
              isLightTheme ? 'text-[#747474]' : 'text-[#B9B9B9]'
            } font-inter-tight text-sm`}
          >
            {data?.form_description}
          </p>
          {data?.form_btn && data?.form_btn_url && (
            <Link
              href={data?.form_btn_url}
              className={`block mx-auto mt-[23px] py-4 rounded-full w-full font-inter-tight font-medium text-center leading-none ${
                isLightTheme ? 'bg-black text-white' : 'bg-white text-[#085157]'
              }`}
            >
              {data?.form_btn}
            </Link>
          )}
        </div>
      </div>
    </article>
  );
};
